import { Component, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs';

import { ScriptLoader } from '@spartacus/core';

import { AbstractComponent } from '../abstract-component.component';
import { ConfigurationService } from '../../../services';
import { ZoovuInterface } from '../../../models';

@Component({
  selector: 'wc-zoovu-cms',
  templateUrl: './zoovu-cms.component.html',
  standalone: true
})
export class ZoovuCMSComponent extends AbstractComponent<ZoovuInterface> implements OnInit {
  constructor(
    private scriptLoader: ScriptLoader,
    private configService: ConfigurationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.component$
      .pipe(takeUntil(this.destroy$))
      .subscribe((component: ZoovuInterface) => {
        const config = this.configService.config;
        this.scriptLoader.embedScript({
          src: `${config?.zoovu?.baseUrl}/${component.accountId}/${component.assistantName}`
        });

        this.setLoaded();
      });
  }
}
